import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DeviceInteractionType } from '../device-interactions-list/device-interactions-list.component';
import { MultiDeviceInteractionState } from '../../models/consumer/consumer-interaction.model';

@Component({
    selector: 'multi-device-interactions-submit',
    templateUrl: './multi-device-interactions-submit.component.html',
    styles: []
})
export class MultiDeviceInteractionsSubmitComponent {

    constructor(
        private router: Router,
        private route: ActivatedRoute
    ) { }

    newInteraction() {
        window.sessionStorage.removeItem("multi-device-interaction");
        this.router.navigate(['../create'], {
            relativeTo: this.route,
            queryParams: { state: MultiDeviceInteractionState.what }
        });
    }

    navigateToDeviceInteraction(isDirect?: boolean) {
        window.sessionStorage.removeItem("multi-device-interaction");
        this.router.navigate(['../../deviceinteractions'], {
            relativeTo: this.route,
            queryParams: { tab: isDirect ? DeviceInteractionType.Multiple : undefined }
        });
    }
}
